module.exports = __webpack_public_path__ + "img/road_straight.775bde0b.svg";